import { useStaticQuery, graphql } from 'gatsby';

const useTestimonials = () => {
  const data = useStaticQuery(graphql`
    query useTestimonialsQuery {
      allSanityTestimonial {
        nodes {
          _rawQuote(resolveReferences: { maxDepth: 10 })
          isFeatured
          jobTitle
          location
          portrait {
            alt
            asset {
              gatsbyImageData
            }
          }
          service {
            name
          }
        }
      }
    }
  `);

  const testimonials = data.allSanityTestimonial.nodes;

  return testimonials;
};

export { useTestimonials };
